import type { UserType } from '@/store/types/user'

const generateOfficeRedirectURL = ({ user }: { user: UserType }) => {
  const stringToken = user.token ?? ''
  const encodedToken = btoa(stringToken)

  return `${process.env.NEXT_PUBLIC_UNICITY_OFFICE_APP_BASE_URL}/#/login/sl/${encodedToken}`
}

export default generateOfficeRedirectURL
